enum ButtonType {
  Button = "button",
  Submit = "submit",
  Reset = "reset",
}

export default ButtonType;
